module.exports = __webpack_public_path__ + "img/screen3.fb9789b1.jpg";